import { Component, OnInit, OnDestroy } from '@angular/core';
import { AnnuityItemsViewModel } from '../../../models/annuity-view.model';
import { DickerSelectListItem, CSPItemListViewModel } from '../../../models/csp.model';
import { ManageService } from '../../../services/manage.service';
import { CommonService } from '../../../services';
import { ActivatedRoute, Router } from '@angular/router';
// tslint:disable-next-line:import-blacklist
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CustomerService } from '../../../services/customer.service';
import { DDCustomer } from '../../../models/customer.model';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-add-subscriptions',
  templateUrl: './add-subscriptions.component.html',
  styleUrls: ['./add-subscriptions.component.css']
})
export class AddSubscriptionsComponent implements OnInit, OnDestroy {

  title = 'Add Subscriptions';
  searchAnnuity: string;
  annuityItemsFilter: AnnuityItemsViewModel[];
  selectedSubscriptionType: string;
  totalPriceChange: number;
  activeTotal: number;
  pendingTotal: number;
  annuityItemsPendingList: AnnuityItemsViewModel[] = [];
  cspItemList: DickerSelectListItem[];
  annuityItems: AnnuityItemsViewModel[];
  loadContent = false;
  tenantId: string;
  setFullWindow = false;
  ngUnsubscribe: Subject<void> = new Subject<void>();
  hideAddButton = false;

  constructor(
    private manageService: ManageService,
    private customerService: CustomerService,
    private cs: CommonService,
    private activatedRoute: ActivatedRoute,
    private router: Router) { }

  ngOnInit() {
    this.loadContent = false;
    $('#levelOne').animate({ scrollLeft: $('#managecsp').width() + 505 }, 400);
    this.manageService.currentPendingSubscriptions.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: AnnuityItemsViewModel[]) => {
      this.annuityItemsPendingList = res;
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
    this.activatedRoute.parent.url.pipe(takeUntil(this.ngUnsubscribe)).subscribe(url => {
      this.tenantId = url[1].path;
      this.manageService.GetCSPItemListView(this.tenantId).subscribe((result: CSPItemListViewModel) => {
        this.cspItemList = result.subscriptionTypes;
        this.selectedSubscriptionType = this.cspItemList[0].value;
        this.manageService.GetCSPtems(this.tenantId, this.selectedSubscriptionType).subscribe((res: AnnuityItemsViewModel[]) => {
          this.annuityItems = res;
          this.annuityItems.forEach(item => {
            item.quantity = '1';
            item.minMaxQtyText = '';
            if (item.minQty) {
              item.minMaxQtyText += 'Min Order Qty - ' + this.cs.toInteger(item.minQty.replace(',', '')).toString() + ' ';
              item.quantity = this.cs.toInteger(item.minQty.replace(',', '')).toString();
            }
            if (item.maxQty) {
              item.minMaxQtyText += 'Max Order Qty - ' + this.cs.toInteger(item.maxQty.replace(',', '')).toString() + ' ';
            }
          });
          this.annuityItemsFilter = this.annuityItems;
          this.loadContent = true;
        },
          (error: any) => {
            console.error(error);
            this.loadContent = true;
          });
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        });
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
  }

  filterAnnuityItems(): void {
    this.annuityItemsFilter = this.annuityItems.filter(annuityItem => annuityItem.description.toLowerCase().includes(this.searchAnnuity.toLowerCase()) || annuityItem.stockCode.toLowerCase().includes(this.searchAnnuity.toLowerCase()));
  }

  changeQty(annuityItem: AnnuityItemsViewModel): void {
    if (!annuityItem.quantity) {
      annuityItem.quantity = '1';
    } else {
      if (annuityItem.minQty) {
        if (this.cs.toInteger(annuityItem.quantity) < this.cs.toInteger(annuityItem.minQty.replace(',', ''))) {
          annuityItem.quantity = this.cs.toInteger(annuityItem.minQty.replace(',', '')).toString();
        }
      }
      if (annuityItem.maxQty) {
        if (this.cs.toInteger(annuityItem.quantity) > this.cs.toInteger(annuityItem.maxQty.replace(',', ''))) {
          annuityItem.quantity = this.cs.toInteger(annuityItem.maxQty.replace(',', '')).toString();
        }
      }
    }
  }

  _keyPress(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  AddAnnuityItem(annuityItem: AnnuityItemsViewModel): void {

    this.loadContent = false;
    if (!this.annuityItemsPendingList.filter(item => item.stockCode === annuityItem.stockCode).length) {
      annuityItem.totalPrice = this.cs.toNumber(annuityItem.itemPrice.replace('$', '').replace(',', '')) * this.cs.toNumber(annuityItem.quantity);
      this.annuityItemsPendingList.push(annuityItem);

      if (annuityItem.stockGroup === '85CU') {
        this.hideAddButton = true;
      }

    } else {
      this.annuityItemsPendingList.filter(item => item.stockCode === annuityItem.stockCode)[0].quantity = (this.cs.toNumber(this.annuityItemsPendingList.filter(item => item.stockCode === annuityItem.stockCode)[0].quantity) + this.cs.toNumber(annuityItem.quantity)).toString();
      this.annuityItemsPendingList.filter(item => item.stockCode === annuityItem.stockCode)[0].totalPrice = this.cs.toNumber(annuityItem.itemPrice.replace('$', '').replace(',', '')) * this.cs.toNumber(annuityItem.quantity);
    }
    this.loadContent = true;
    // this.commonService.showSuccess("#"+annuityItem.stockCode, "New Item added", "right");
    this.cs.implementToast('New Item added', 'Success');
    this.manageService.monitorMPNIDCheckStatus(false);
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  changeSubscriptionType(): void {
    this.loadContent = false;
    if (this.selectedSubscriptionType === '85CU') {
      this.cs.implementToast('Getting eligible Azure products from Microsoft....', 'Info');
    }
    this.manageService.GetCSPtems(this.tenantId, this.selectedSubscriptionType).subscribe((res: AnnuityItemsViewModel[]) => {
      this.annuityItems = [];
      this.annuityItems = res;
      this.annuityItems.forEach(item => {
        if (this.cs.toNumber(item.itemPrice.replace('$', '').replace(',', '')) === 0) {
          item.disableQty = true;
        }
      });
      this.annuityItemsFilter = this.annuityItems;
      this.loadContent = true;
    },
      (error: any) => {
        this.loadContent = true;
        console.error(error);
      });
  }

  toHTML(input: any): any {
    return new DOMParser().parseFromString(input, 'text/html').documentElement.innerHTML;
  }

  finishAddSubscriotions(): void {
    this.manageService.monitorPendingSubscriptions(this.annuityItemsPendingList);
    this.manageService.monitorSelectedTabIndex(0);
    if (this.cs.isInCustiomerMenu()) {
      this.customerService.currentCustomerWatch.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: DDCustomer) => { 
        this.router.navigateByUrl("/customers/" + res?.id  + "/CSP/" + this.tenantId);
      });
    } else {
      this.router.navigateByUrl("/manageSubscriptions/manageAnnuities/CSP/CSPDetailsNew/" + this.tenantId);
    }
  }

  close() {
    this.manageService.monitorPendingSubscriptions(this.annuityItemsPendingList);
    this.manageService.monitorSelectedTabIndex(0);
    if (this.cs.isInCustiomerMenu()) {
      this.customerService.currentCustomerWatch.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: DDCustomer) => { 
        this.router.navigateByUrl("/customers/" + res?.id  + "/CSP/" + this.tenantId);
      });
    } else {
      this.router.navigateByUrl("/manageSubscriptions/manageAnnuities/CSP/CSPDetailsNew/" + this.tenantId);
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
